var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('pop-prompt', {
    attrs: {
      "className": "popRewardspins",
      "isClose": false,
      "title": " ",
      "confirmText": "Ok",
      "content": "html",
      "show": _vm.taskInfo.popCoinAnim.show,
      "isBtnCancel": false
    },
    on: {
      "confirm": _vm.onAccept,
      "update:show": function ($event) {
        return _vm.$set(_vm.taskInfo.popCoinAnim, "show", $event);
      }
    }
  }, [_vm.taskInfo ? _c('div', {
    staticClass: "pop-rewardspins"
  }, [_c('div', {
    staticClass: "pop-rewardspins__title"
  }, [_vm._v("Congratulations on getting")]), _c('div', {
    staticClass: "pop-rewardspins__reward"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.aiSkin}/icon-${_vm.taskInfo.popCoinAnim.icon}.png`),
      "alt": ""
    }
  }), _c('span', [_vm.isCountUpAnim && _vm.userInfo && _vm.userInfo.vip_bonus > 0 ? [_c('m-count-up', {
    attrs: {
      "endVal": Number(_vm.taskInfo.popCoinAnim.reward * _vm.userInfo.vip_bonus * 0.01 + _vm.taskInfo.popCoinAnim.reward)
    }
  })] : [_vm._v(_vm._s(_vm.fmt_pre(_vm.taskInfo.popCoinAnim.reward)))]], 2)]), _vm.taskInfo.popCoinAnim.icon == 'coin' && _vm.userInfo && _vm.userInfo.vip_bonus > 0 ? _c('div', {
    staticClass: "pop-rewardspins__vip",
    class: _vm.isVipAnim && 'vipanim'
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("VIP" + _vm._s(_vm.userInfo.vip_level))]), _c('span', {
    staticClass: "num"
  }, [_vm._v("+" + _vm._s(_vm.fmt_pre(_vm.taskInfo.popCoinAnim.reward * _vm.userInfo.vip_bonus * 0.01)))])]) : _vm._e()]) : _vm._e()]), _c('div', {
    ref: "destoryCoinContainerRef",
    staticClass: "getCoinAnim-container"
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };